import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/broadway-2022/sponsors/symphony-season.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Utah Symphony 2022–23 Season coming soon',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/Noorda-ad.jpg',
      link: 'https://www.uvu.edu/noorda',
      alt: 'Upcoming shows at the Noorda',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/holland.jpg',
      link: 'https://www.hollandhart.com',
      alt: 'Holland and Hart',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/teoma.jpg',
      link: 'https://www.teomaglobal.com',
      alt: 'Teoma Global',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/pbsutah.jpg',
      link: 'https://www.pbsutah.org',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/Classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/upcoming.jpg',
      link: 'https://www.utahsymphony.org/',
      alt: 'Utah Symphony Upcoming concerts',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/series-subscriptions.jpg',
      link: 'https://www.utahsymphony.org/das',
      alt: 'Utah Symphony Design a Series',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/Eccles-Symphony-ad.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/millcreek.jpg',
      link: 'https://www.millcreekcoffee.com/',
      alt: 'Mill Creek',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/Ghostlight_Sep.jpg',
      link: 'https://soundcloud.com/utahsymphony',
      alt: 'Ghostlight Podcast',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/harry-potter.jpg',
      link: 'https://utahsymphony.org',
      alt: 'Harry Potter and the Half Blood Prince in Concert',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/ruth-chris.jpg',
      link: 'https://www.ruthschris.com/restaurant-locations/salt-lake-city/',
      alt: 'Ruths Chris Steakhouse',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/ufs.jpg',
      link: 'https://utahfoodservices.com/',
      alt: 'Utah Symphony Volunteer Benefits',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/education.jpg',
      link: 'https://www.utahsymphony.org/connecting-to-schools',
      alt: 'Utah Symphony Education information',
      class: 'webFormat',
    },
    {
      image: '/broadway-2022/sponsors/guild.jpg',
      link: 'https://www.utahsymphonyguild.org',
      alt: 'Utah Symphony Guild information',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
